import styled from '@emotion/styled';

import colors from 'config/theme/colors';
import Button from 'ui/base/Button';
import BaseDragger from 'ui/base/Dragger';
import BaseModal from 'ui/base/Modal';
import Select from 'ui/base/Select';

import { RadioGroup } from '../../interventions/detail/medias/UI';

const MODAL_HEIGHT = 973;

export const Modal = styled(BaseModal)`
  &.full-screen {
    .ant-modal {
      top: 20px;
      max-width: 100%;
      .ant-modal-body {
        height: calc(100vh - 182px);
      }
    }
  }
  .ant-modal-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    overflow-y: auto;
    height: calc(${MODAL_HEIGHT}px - 142px);
    min-height: 578px !important;
    padding: 0;
    @media (max-height: 1080px) {
      height: calc(100vh - 200px - 142px);
    }
  }
`;

export const RadioGroupUpload = styled(RadioGroup)`
  width: fit-content;
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: calc(100% - 184px);
  width: 100%;
  border-bottom: 1px dashed ${colors['@border-color-base']};
  padding-bottom: 16px;
  position: relative;
`;

export const ImportedFileSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  padding-bottom: 16px;
  align-items: flex-start;
  width: 100%;
  .title {
    font-weight: 700;
    font-size: 16px;
  }
  .media-max {
    font-weight: 600;
    font-size: 13px;
    color: ${colors['@text-color-secondary']};
  }
`;

export const ImportedFileList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(101.5px, 1fr));
  gap: 8px;
  padding: 12px;
  width: 100%;
  height: 128px;
  overflow: auto;

  background: ${colors['@body-bg']};
  border-radius: 8px;
  margin-top: 16px;
`;

export const DraggerWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  > span {
    height: 100%;
    width: 100%;
  }
`;

export const Dragger = styled(BaseDragger)`
  background: linear-gradient(180deg, #fafcff 0%, #f1f6ff 100%), #ffffff !important;
  
  span {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  &.rounded {
    border-radius: 10px !important;

    > .ant-upload {
      &-drag {
        border-radius: 10px;
        border-color: ${colors['@grey-20']};
      }
    }
  }
`;

export const StyledDraggerContent = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: center;

  .fb-icon--upload-file {
    font-size: 28px;
    display: flex;
    background-color: white;
    border: 18px solid white;
    border-radius: 50%;
    color: ${colors['@primary-color']};
    margin-bottom: 20px;
    width: auto;
  }
  .drag-text {
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    color: ${colors['@text-color-secondary']};
    margin-bottom: 8px;
  }
  .or-text {
    font-weight: 400;
    font-size: 13px;
    margin-bottom: 8px;
    color: ${colors['@text-color-secondary']};
  }
  .browse-button {
    width: fit-content;
  }
`;

export const FromLibraryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: calc(100% - 44px);
  background: ${colors['@body-bg']};
  border-radius: 8px;
  overflow: hidden;
`;

export const LibraryHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  margin-bottom: 0;
  gap: 16px;
  width: 100%;
  justify-content: center;
  align-items: center;
  z-index: 10;
  padding-bottom: 16px;
  > span {
    font-weight: 700;
  }
  > .ant-input-search {
    width: 180px;
  }
`;

export const Error = styled('div', { target: 'fb-upload-modal-error' })`
  display: flex;
  justify-content: center;
  align-items: center;

  background: #fff7e8;
  border-radius: 6px;
  padding: 16px;
  z-index: 1000;

  > i {
    color: white;
    padding: 8px;
    font-size: 15px;
    background: #ef9400;
    border-radius: 130px;
    margin-right: 16px;
  }
`;

export const TakePicture = styled.div`
  max-width: 100%;
  height: calc(100% - 68px);
  aspect-ratio: 16/9;
  position: relative;

  > div:not(${Error}) {
    position: relative;
    border: 1px dashed ${colors['@border-color-base']};
    border-radius: 10px;
  }

  > ${Error} {
    width: 90%;
    position: absolute;
    top: calc(50% - 33px);
    left: 5%;
  }
`;

export const StyledThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  height: 80px;
  width: 80px;
  border-radius: 12px;
  margin-top: 12px;
  background-color: ${colors['@body-bg']};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('${({ background }) => background}');
  will-change: transform;
`;

export const ImportedFile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 104px;
  background-color: white;
  box-shadow: 0px 0px 5px rgba(109, 141, 173, 0.05);
  border-radius: 8px;
  position: relative;

  &:not(.error) {
    &:hover .thumbnail:after {
      content: '';
      bottom: 0;
      top: 0;
      right: 0;
      left: 0;
      position: absolute;
      z-index: 10;
    }
  }
`;

export const ImportedFileButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: ${colors['@body-bg']};
  border-radius: 20px;
  border: 0px;

  &:hover {
    border: none !important;
  }
`;

export const ColoredIcon = styled.i`
  color: ${({ color = colors['@border-color-base'] }) => color};
`;

export const EditFilePanel = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors['@body-bg']};
  border-radius: 8px;
  height: 248px;
  width: 100%;
  z-index: 1001;
  position: absolute;
  bottom: 0;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const EditMediaContent = styled.div`
  display: grid;
  padding: 20px 28px 0 28px;
  grid-template-columns: 120px auto 150px;
  grid-template-rows: 48px 104px;
  grid-auto-flow: row;
  align-items: center;
`;

export const EditThumbnail = styled.div`
  padding: 0px 24px 12px 24px;
  background: white;
  border-radius: 12px 0px 0px 12px;
`;

export const EditInput = styled.div`
  background: white;
  padding: 36px 12px;
`;

export const EditSaveInLibrary = styled.div`
  display: flex;
  align-items: center;
  padding: 36px 12px 36px 12px;
  background: white;
  border-radius: 0px 12px 12px 0px;
  > .ant-btn[disabled] {
    background-color: white !important;
  }
`;

export const EditTitle = styled.div`
  padding: 0 12px;
  span {
    font-weight: 500;
  }
`;

export const NoImportedFile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  width: 100%;
  background: ${colors['@body-bg']};
  border-radius: 8px;
  height: 128px;
  > span {
    font-weight: 500;
    font-size: 13px;
  }
`;

export const SelectLibrary = styled(Select)`
  width: 220px !important;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 102px;
  width: 102px;
  background: white;
  border-radius: 60px;
`;

export const ImportedFilesMask = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1000;
  background-color: ${({ isUploaded }) => (isUploaded ? 'rgba(34, 110, 89, 0.45)' : 'rgba(255, 0, 0, 0.2)')};
  border-radius: 8px;
  > i {
    font-size: 28px;
    color: white;
  }
`;

export const LibraryWrapper = styled.div`
  width: 100%;
  overflow: auto;
  z-index: 0;
  padding: 0 16px 16px 16px;
`;

export const MediaButton = styled.div`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  z-index: 20;
  position: absolute;
  bottom: 17px;
`;

export const ErrorByMedia = styled.div`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  color: ${colors['@error-color']};
  z-index: 10;
  height: 100%;
  width: 100%;
  position: absolute;
  border-radius: 8px;
  align-items: flex-start;
  justify-content: center;
  padding-top: 18px;
  font-weight: 600;
    
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: ${colors['@error-color']};
    opacity: 0.4;
    border-radius: 8px;
  }
`;

export const ErrorBadge = styled.div`
  z-index: 11;
  display: flex;
  align-items: center;
  gap: 3px;
  background-color: ${colors['@white']};
  border-radius: 10px;
  padding: 3px 7px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    
  .error-icon {
    font-size: 16px;
    cursor: pointer;
  }
`;

export const MaskContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 8px;
`;

export const Mask = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.45);
  inset: 0;
  z-index: 20;
`;
